import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { IconButton } from '@material-ui/core';

const useStyles = makeStyles({
    root: {
        minWidth: 275,
        borderLeft: "3px solid #551a8b !important"
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});

export default function CardQuestion({ date, onClick }) {
    const classes = useStyles();
    const bull = <span className={classes.bullet}>•</span>;

    return (
        <Card className={classes.root} variant="outlined">
            <CardContent>
                <Typography variant="h5" style={{ color: "#551a8b" }} component="h2">
                    {date.name}
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                    {date.describe}
                </Typography>
            </CardContent>
            <CardActions>
                {/* <IconButton size="small" style={{color: "#000000", paddingLeft: 10}} onClick={onClick}>
                    <PostAddIcon />
                </IconButton> */}
                <Button variant="outlined" color="primary" onClick={onClick}>Responder encuesta</Button>
            </CardActions>
        </Card>
    );
}